
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rgb-color-picker-from-image",
      function () {
        return require("private-next-pages/rgb-color-picker-from-image/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rgb-color-picker-from-image"])
      });
    }
  